import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {BruteForce} from "../BruteForce";
import {BruteForceGameConfig} from "../BruteForceGameConfig";
import {BLEND_MODES} from "pixi.js";

export class BruteForceAnticipationView extends PIXI.Container implements StageLayer {

    private _scatterContainer: TimelineSprite[];
    private _boostedBetHighlight: PIXI.Sprite;
    private _isXBetOn: boolean = false;


    constructor() {
        super();
        this.name = "BruteForceAnticipationView";
        this.init();
        this.scale.set(1.2, 1.2);
    }

    public startAnticipationOnNextReel(reelNo: number): void {
        //safe check incase reelstop non sequentially
        if (reelNo === 3 || reelNo === 4) {
            BruteForceGameConfig.isScatterAnticipationOnReelActive[reelNo] = true;
            this._scatterContainer[reelNo - 3].visible = true;
            BruteForce.allreelsView.reelModels[reelNo].reelView.scatterContainer.addChildAt(this._scatterContainer[reelNo - 3], 0);
            this._scatterContainer[reelNo - 3].position.set(0, 192);
            this._scatterContainer[reelNo - 3].show();
            this._scatterContainer[reelNo - 3].playLoop();
        }
    }


    public stopCurrentReelAnticipation(reelNo: number): void {
        if (reelNo === 3 || reelNo === 4) {
            BruteForceGameConfig.isScatterAnticipationOnReelActive[reelNo] = false;
            this._scatterContainer[reelNo - 3].stopLoop();
            this._scatterContainer[reelNo - 3].hide();
        }
    }

    public updateXBetState(): void {
        const activeBetFeature = BruteForce.apiPlugin.betFeatureController.getActiveBetFeature();
        const isOn = activeBetFeature?.name == "BOOSTED_BET";
        if (this._isXBetOn == isOn) {
            return;
        }
        this._boostedBetHighlight.visible = isOn;
        this._isXBetOn = isOn;
    }

    public closeXBetHighlight(): void {
        this._boostedBetHighlight.visible = false;
        this._isXBetOn = false;
    }

    private init(): void {
        this._scatterContainer = [];
        for (let reelId: number = 3; reelId < 5; reelId++) {
            const reelAnticipationSeq: TimelineSprite = new TimelineSprite(BruteForce.assetLoader.getTextures("scatterAnticipation"));
            reelAnticipationSeq.visible = false;
            reelAnticipationSeq.hide();
            reelAnticipationSeq.blendMode = BLEND_MODES.ADD;
            reelAnticipationSeq.scale.set(1, 1);
            reelAnticipationSeq.anchor.set(0.5, 0.5);
            reelAnticipationSeq.name = `${reelId}`;
            reelAnticipationSeq.position.set(BruteForceGameConfig.reelSetPositionX + BruteForceGameConfig.symbolWidth * reelId - 10, 290);
            this.addChild(reelAnticipationSeq);
            this._scatterContainer.push(reelAnticipationSeq);

        }


        this._boostedBetHighlight = new PIXI.Sprite(BruteForce.assetLoader.getTextures("xBetReelAttention2")[0]);
        this._boostedBetHighlight.anchor.set(0.5);
        this._boostedBetHighlight.position.set(180, 293);
        this._boostedBetHighlight.name = "xBetReelAttention";
        this._boostedBetHighlight.blendMode = BLEND_MODES.ADD;
        this._boostedBetHighlight.visible = false;

        this.addChild(this._boostedBetHighlight);
    }


}